import moment from "moment";
import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import Modal from "../../../../../components/modal";
import Button from "../../../../../components/button";
import { DayPicker } from "react-day-picker";
import { SelectUsers } from "../../campaign/select-users";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from "../../../dashboard-context";
import Popover from "@material-ui/core/Popover";
import {
  addSurveySchedule,
  updateSurveySchedule,
  loadProfile,
} from "../../../../../api";
import Select from "../../../../../components/select";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableHeadRow,
  TableBodyRow,
  HeadCell,
  DataCell,
} from "../../../../../components/table";

const AddButton = styled(Button)`
  margin: 0;
  min-width: 120px;
  margin-left: 16px;
`;

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1600px;
  padding: 16px 0px;
`;

const TableTitle = styled.h2`
  display: flex;
  align-items: center;
  margin: 10px auto 10px auto;
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`;

const Label = styled.label`
  color: #333333;
  display: block;
  font-family: DM Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: bold;
  margin-bottom: 8px;
`;

const DayButton = styled(Button)`
  background: ${props => props.theme.input.background};
  border: 1px solid #dddee8;
  color: #5a5a5a;
  font-weight: 400;
  padding: 4px 8px;
  margin: 0;
  width: 180px;
`;

const Info = styled.p`
  font-family: DM Sans, sans-serif;
  font-size: 0.875rem;
  margin: -10px 0 00;
`;

const CustomDayPicker = ({ day, setDay }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const disabledDays = [{ before: new Date() }];

  return (
    <div>
      <div style={{ display: "block" }}>
        <Label>Send Date</Label>
        <div style={{ minWidth: "120px" }}>
          <DayButton
            onClick={handleClick}
            label={moment(day).format("MM/DD/YYYY")}
          />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <DayPicker
          disabled={disabledDays}
          modifiersStyles={{ selected: { backgroundColor: "#1fc44a" } }}
          selected={day}
          onDayClick={(day) => {
            setDay(day);
          }}
        />
      </Popover>
    </div>
  );
};

const ScheduledAssignmentModal = ({
  open,
  onClose,
  forms,
  modalType,
  selectedScheduleId,
}) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user, updateUser } = useContext(AuthContext);
  const [day, setDay] = useState(new Date());
  const [showClients, setShowClients] = useState(false);
  const [currentSelected, setCurrentSelected] = useState([]);
  const [timeHour, setTimeHour] = useState({ label: "12", value: "12" });
  const [timeMinute, setTimeMinute] = useState({ label: "00", value: "0" });
  const [timeAMPM, setTimeAMPM] = useState({ label: "PM", value: "PM" });
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [scheduleType, setScheduleType] = useState({
    label: "Assign client(s) to check-in form",
    value: "0",
  });

  useEffect(() => {
    if (modalType === "edit" && selectedScheduleId && user.survey_schedules) {
      const schedule = user.survey_schedules.find(
        (s) => s.id === selectedScheduleId
      );
      if (schedule) {
        const scheduleDate = new Date(schedule.schedule_date);
        setDay(scheduleDate);

        let hours = scheduleDate.getHours();
        const minutes = scheduleDate.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";

        if (hours === 0) {
          hours = 12;
        } else if (hours > 12) {
          hours = hours - 12;
        }

        setTimeHour({ label: hours.toString(), value: hours.toString() });
        setTimeMinute({
          label: minutes.toString().padStart(2, "0"),
          value: minutes.toString(),
        });
        setTimeAMPM({ label: ampm, value: ampm });
        setSelectedFormId({
          label:
            forms.find((f) => f.id === schedule.survey_id)?.name ||
            "Untitled Form",
          value: schedule.survey_id,
        });
        setScheduleType({
          label:
            schedule.schedule_type === 0
              ? "Assign client(s) to check-in form"
              : "Delete client(s) from check-in form",
          value: schedule.schedule_type.toString(),
        });

        setCurrentSelected(schedule.account_ids || []);
      }
    } else if (modalType === "create") {
      setDay(new Date());
      setTimeHour({ label: "12", value: "12" });
      setTimeMinute({ label: "00", value: "0" });
      setTimeAMPM({ label: "PM", value: "PM" });
      setSelectedFormId(null);
      setScheduleType({ label: "Assign client(s) to check-in form", value: "0" });
      setCurrentSelected([]);
    }
  }, [modalType, selectedScheduleId]);

  const handleAssignSurvey = (selected) => {
    setCurrentSelected(selected);
    setShowClients(false);
  };

  const handleSave = () => {
    let hours = parseInt(timeHour.value);
    if (timeAMPM.value === "PM" && hours !== 12) {
      hours += 12;
    } else if (timeAMPM.value === "AM" && hours === 12) {
      hours = 0;
    }
    const scheduleDateTime = new Date(
      day.setHours(hours, parseInt(timeMinute.value), 0, 0)
    );
    const scheduleDateTimeUTC = new Date(scheduleDateTime.toUTCString());
    const now = new Date();
    const nowUTC = new Date(now.toUTCString());

    if (scheduleDateTimeUTC < nowUTC) {
      openSnackbar("Schedule date must be in the future", true);
      return;
    } else if (!selectedFormId && parseInt(scheduleType.value) === 0) {
      openSnackbar("Please select a form", true);
      return;
    } else if (!currentSelected.length) {
      openSnackbar("Please select at least one client", true);
      return;
    }

    const data = {
      survey_id: parseInt(scheduleType.value) === 0 ? selectedFormId.value : null,
      schedule_date: scheduleDateTimeUTC,
      schedule_type: parseInt(scheduleType.value),
      account_ids: currentSelected,
    };

    if (modalType === "create") {
      addSurveySchedule(user.id, data)
        .then((res) => {
          onClose();
          openSnackbar("Schedule created", false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          console.log(err);
          openSnackbar("Error creating schedule", true);
        });
    } else if (modalType === "edit") {
      updateSurveySchedule(user.id, selectedScheduleId, data)
        .then((res) => {
          onClose();
          openSnackbar("Schedule updated", false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          console.log(err);
          openSnackbar("Error updating schedule", true);
        });
    }
  };

  return (
    <>
      <Modal
        title={
          modalType === "edit"
            ? "Edit Scheduled Assignment"
            : "Create Scheduled Assignment"
        }
        onClose={onClose}
        open={open}
        maxWidth="lg"
        handleSubmit={handleSave}
        submitLabel="Save"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              flexDirection: "column",
            }}
          >
            <Select
              options={[
                { label: "Assign client(s) to check-in form", value: "0" },
                { label: "Delete client(s) from check-in form", value: "1" },
              ]}
              value={scheduleType}
              onChange={(val) => setScheduleType(val)}
              label="Schedule Type"
            />
            {scheduleType.value === "0" && (
              <Info>*This will overwrite any existing check-in form assignments for the selected clients.</Info>
            )}
            {scheduleType.value === "1" && (
              <Info>*This will delete any check-in form assignments for the selected clients.</Info>
            )}
            {scheduleType.value === "0" && (
              <Select
                options={forms.map((form) => ({
                  label: form.name || "Untitled Form",
                  value: form.id,
                }))}
                value={selectedFormId}
                onChange={(val) => setSelectedFormId(val)}
                label="Form"
              />
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "16px",
              }}
            >
              <CustomDayPicker day={day} setDay={setDay} />
              <Select
                options={[
                  { label: "12", value: "12" },
                  { label: "1", value: "1" },
                  { label: "2", value: "2" },
                  { label: "3", value: "3" },
                  { label: "4", value: "4" },
                  { label: "5", value: "5" },
                  { label: "6", value: "6" },
                  { label: "7", value: "7" },
                  { label: "8", value: "8" },
                  { label: "9", value: "9" },
                  { label: "10", value: "10" },
                  { label: "11", value: "11" },
                ]}
                value={timeHour}
                onChange={(val) => setTimeHour(val)}
                label="Hour"
              />
              <Select
                options={[
                  { label: "00", value: "0" },
                  { label: "15", value: "15" },
                  { label: "30", value: "30" },
                  { label: "45", value: "45" },
                ]}
                value={timeMinute}
                onChange={(val) => setTimeMinute(val)}
                label="Minute"
              />
              <Select
                options={[
                  { label: "AM", value: "AM" },
                  { label: "PM", value: "PM" },
                ]}
                value={timeAMPM}
                onChange={(val) => setTimeAMPM(val)}
                label="AM/PM"
              />
            </div>
          </div>
          <Container>
            <TableTitle>
              Clients selected for this schedule
              <AddButton
                label="Select Clients"
                onClick={() => setShowClients(true)}
              />
            </TableTitle>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableHeadRow>
                    <HeadCell>Email Address</HeadCell>
                    <HeadCell>Name</HeadCell>
                  </TableHeadRow>
                </TableHead>
                <TableBody>
                  {currentSelected.map((clientID) => {
                    const client = user.accounts.find((c) => c.id === clientID);
                    return (
                      <TableBodyRow key={clientID}>
                        <DataCell>{client.email_address}</DataCell>
                        <DataCell>{client.name}</DataCell>
                      </TableBodyRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        </div>
      </Modal>
      <SelectUsers
        heading="Select clients to be assigned this check-in form"
        currentSelected={currentSelected}
        submit={(selected) => handleAssignSurvey(selected)}
        open={showClients}
        onClose={() => setShowClients(false)}
      />
    </>
  );
};

export default ScheduledAssignmentModal;
